<template>
  <v-dialog v-model="value"
            ref="dialog"
            width="600"
            scrollable
            persistent
            eager
            v-bind="$attrs"
            @keydown.esc="close"
            @click:outside="close">
    <v-card class="app-card card-borderless">
      <gg-toolbar @close="close">
        {{ toolbarText }}
      </gg-toolbar>
      <v-card-text class="pt-2 pb-3">
        <slot></slot>
      </v-card-text>
      <v-card-actions class="justify-content-end pb-4">
        <gg-btn secondary @click="cancel">{{ cancelText }}</gg-btn>
        <gg-btn primary :loading="loading" @click="confirm">{{ confirmText }}</gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmationModal',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean
    },
    toolbarText: {
      type: String,
      default: 'Confirm Your Action'
    },
    confirmText: {
      type: String,
      default: 'Confirm'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    confirm () {
      this.$emit('confirm')
    },
    cancel () {
      this.$emit('cancel')
      this.close()
    },
    close () {
      this.$emit('change', false)
    },
  }
}
</script>
